import { get } from 'lodash';

const getFieldError = (touched, errors, field) =>
  get(touched, field) && get(errors, field);

export default getFieldError;
